import { SxProps } from "@mui/material";
import { SelectFromList } from "../../../components/SelectFromList";
import { useProducts } from "../../../features/products/product-func";
export const CategorySelect = ({
  categoryId,
  onChange,
  defaultLabel,
  sx,
  error,
  startMenu,
  helpText,
  label,
  disabled,
}: {
  categoryId?: string;
  onChange: (categoryId: string) => void;
  defaultLabel?: string;
  sx?: SxProps;
  error?: string;
  startMenu?: { value: string; name: string }[];
  helpText?: string | React.ReactNode;
  label?: string;
  disabled?: boolean;
}) => {
  const { categoryNames } = useProducts();

  return (
    <SelectFromList
      entries={categoryNames.map((c) => ({
        value: c.value,
        name: `${c.name} (${c.count})`,
        level: c.level,
      }))}
      value={categoryId ?? ""}
      setValue={(v) => onChange(v ?? "")}
      defaultLabel={defaultLabel}
      label={categoryId ? label || "Category" : ""}
      size="small"
      sx={sx}
      error={error}
      startMenu={startMenu}
      helpText={helpText}
      disabled={disabled}
    />
  );
};
